import {BufferAttribute, BufferGeometry} from "three";

let geom;

export function useSightlineGeometry()
{
    if (!geom) {
        geom = new BufferGeometry();
        const pos = new Float32Array([ 0.0, 0.0, 0.0, -0.5, 0.5, 1.0, 0.5, 0.5, 1.0, 0.5, -0.5, 1.0, -0.5, -0.5, 1.0 ]);
        geom.addAttribute("position", new BufferAttribute(pos, 3));
        const index = [0, 1, 2, 0, 2, 3, 0, 3, 4, 0, 4, 1];
        geom.setIndex(index);
    }

    return geom;
}